import React, {Component} from 'react';
import {Modal} from "antd";

class SAModal extends Component {

    constructor(props){
        super(props);
        this.state = {
            visible: props.visible
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible) {
            this.setState({visible:this.props.visible})
        }
    }


    render() {
        const {...rest} = this.props;
        const {visible} = this.state;
        if (!visible){
            return null;
        }
        return (
            <Modal visible={visible} {...rest}>
              {this.props.children}
            </Modal>
        );
    }
}

export default SAModal;

